import React, {useEffect, useState, useRef} from 'react';
import {Input} from "antd";
import {PlusOutlined, SearchOutlined} from "@ant-design/icons";
import print from "../../../../../../icons/print.png";
import pdf from "../../../../../../icons/pdf.png";
import excel from "../../../../../../icons/excel.png";
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {add_func} from "../../../../../../components/functions/Mathematik";
import {user_data} from "../../../../../../components/functions/usr";
import {NavLink} from "react-router-dom";
import {ExcelPrint, Pdf} from "../../../../../../components/functions/Print";
import {useReactToPrint} from "react-to-print";
import { getEnv } from "../../../../../../lib/env";

function Table() {
    const conponentPDF= useRef();
    const [year, setYear] = useState(new Date().toISOString().slice(0,4))
    const [lyear, setLyear] = useState(year)
    const [season, setSeason] = useState('veg')
    const setSearch = (text) => {
        console.log(text)
    }
    let sum1 = [0,0,0,0,0]
    const [data, setData] = useState([])
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitmanbalar/jami?year="+year+"&season="+season, header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Server bilan aloqa yo'q")
                })
            if(res){
                setData(res.data.data)
            }
        }
        fetchData()
    },[year,season])
    const generatePDF= useReactToPrint({
        content: ()=>conponentPDF.current,
        documentTitle:"Userdata",
        onAfterPrint:()=>alert("Data saved in PDF")
    });
    return (
        <>
            <div className="table-content-top">
                <div className="table-top-left">
                    <Input
                        prefix={<SearchOutlined className="site-form-item-icon" />}
                        placeholder="Search"
                        onChange={e=>setSearch(e.target.value)}
                    />
                </div>
                <ul className="table-top-right">
                    {
                        user_data()?user_data().region_id == 1 ?
                            <li>
                                <NavLink to="/limit/manbalar/jami/add" className="btn btn-sm btn-outline-primary d-flex align-items-center">
                                    Ma'lumot kiritish &nbsp;&nbsp;&nbsp;<PlusOutlined/>
                                </NavLink>
                            </li>
                            :null:null
                    }
                    <li className="d-flex align-items-center">
                        <input type="number" className="form-control form-control-sm" min={2015} max={parseInt(new Date().toISOString().slice(0,4))+2} value={lyear} onChange={e=>setLyear(e.target.value)}/>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-sm btn-outline-primary" onClick={()=>setYear(lyear)}>Ok</button>
                    </li>
                    <li>
                        <select className="form-select form-select-sm" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="veg">Sug'orish mavsumi</option>
                            <option value="noveg">Nosug'orish mavsumi</option>
                        </select>
                    </li>
                    <li>
                        <button className="btn p-0" onClick={() => generatePDF()}>
                            <img src={print} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button  onClick={() => Pdf('tblData')} className="btn p-0">
                            <img src={pdf} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button className="btn p-0" onClick={()=>ExcelPrint("Limit 1 - ilova jami", "sheet 1","tblData")}>
                            <img src={excel} alt="404"/>
                        </button>
                    </li>
                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <div ref={conponentPDF} style={{width:'100%'}}>
                <table id="tblData" className="table table-bordered table-style limit">
                    <thead>
                    <tr>
                        <th colSpan={7}>
                            O‘zbekiston Respublikasi bo‘yicha {year}-yilning {season == 'noveg' ? 'no' :null}vegetatsiya davrida suv manbalaridan jami ajratilgan suv olish limiti
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" rowSpan={2}>№</th>
                        <th scope="col" rowSpan={2}>Tashkilot va hududlar nomi</th>
                        <th scope="col" rowSpan={2}>Jami suv olish limiti*</th>
                        <th scope="col" colSpan={4}> shu jumladan, manbalardan</th>
                    </tr>
                    <tr>
                        <th scope="col">Daryo o‘zanidan</th>
                        <th scope="col">Ichki daryo va soylardan</th>
                        <th scope="col">Yer osti suvlaridan</th>
                        <th scope="col">Qaytadan ishlatila-digan (zovur)</th>
                    </tr>
                    </thead>
                    {
                        data.length > 0?
                            data.map((d,i) => {
                                if(i == 0){
                                    let sum1 = [0,0,0,0,0]
                                }
                                    sum1[0] = add_func(sum1[0],d.jami)
                                    sum1[1] = add_func(sum1[1],d.daryo)
                                    sum1[2] = add_func(sum1[2],d.ichki_daryo)
                                    sum1[3] = add_func(sum1[3],d.yer_osti)
                                    sum1[4] = add_func(sum1[4],d.qayta)
                                return <tbody key={i}>
                                <tr>
                                    <th>{i+1}</th>
                                    <th style={{width:'250px',minWidth:'250px'}}>
                                        <p><b>{d.name}</b></p>
                                        <p><i>{d.title}</i></p>
                                    </th>
                                    <th scope="col">{d.jami}</th>
                                    <th scope="col">{d.daryo}</th>
                                    <th scope="col">{d.ichki_daryo}</th>
                                    <th scope="col">{d.yer_osti}</th>
                                    <th scope="col">{d.qayta}</th>
                                </tr>
                                </tbody>
                            })
                            :null
                    }
                    <tbody>
                    <tr>
                        <th colSpan={2} ><b>Jami Respublika bo‘yicha</b></th>
                        <th>{sum1[0]}</th>
                        <th>{sum1[1]}</th>
                        <th>{sum1[2]}</th>
                        <th>{sum1[3]}</th>
                        <th>{sum1[4]}</th>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </>
    );
}

export default Table;

